/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knowledgebase_EmptyInputs */

const en_knowledgebase_empty = /** @type {(inputs: Knowledgebase_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No knowledgebase docs yet.`)
};

const es_knowledgebase_empty = /** @type {(inputs: Knowledgebase_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavia no hay documentos.`)
};

/**
* | output |
* | --- |
* | "No knowledgebase docs yet." |
*
* @param {Knowledgebase_EmptyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const knowledgebase_empty = /** @type {((inputs?: Knowledgebase_EmptyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knowledgebase_EmptyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_knowledgebase_empty(inputs)
	return es_knowledgebase_empty(inputs)
});